export default "__VITE_ASSET__434e3a95__"